import React, { useState, useEffect } from "react";
import { Fab } from "@mui/material"; // Floating Action Button
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward"; // Material UI Arrow Icon

const BackToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Handle scroll event to show/hide button
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    // Scroll to top smoothly
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Same breakpoint as .mobile-sticky-footer (home.css) + room above LiveSquare mobile img (~172px)
    const bottomPosition = window.innerWidth <= 1200 ? "160px" : "88px";

    return (
        <div>
            {isVisible && (
                <Fab 
                    color="primary"
                    size="small"
                    onClick={scrollToTop}
                    style={{
                        position: "fixed",
                        bottom: bottomPosition,
                        right: "20px",
                        zIndex: 1000,
                        // backgroundColor: "#1976D2",
                        backgroundColor: "rgb(12 168 84)",
                        color: "white"
                    }}
                >
                    <ArrowUpwardIcon />
                </Fab>
            )}
        </div>
    );
};

export default BackToTop;